import { createAction, props } from '@ngrx/store';

import { UseCases, UseCaseTypesEnum, UseCaseVdd } from '@vi-iot/client';
import { ExtendedParametersTabsEnum } from './remote-diagnostics-use-cases.model';

export namespace RemoteDiagnosticsUseCasesActions {
  export enum Type {
    LOAD_USE_CASES_ATTEMPT = '[REMOTE DIAGNOSTICS USE CASES] Load use cases attempt',
    LOAD_USE_CASES_SUCCESS = '[REMOTE DIAGNOSTICS USE CASES] Load use cases success',
    LOAD_USE_CASES_FAILED = '[REMOTE DIAGNOSTICS USE CASES] Load use cases failed',

    LOAD_USE_CASE_VDD_LIST_ATTEMPT = '[REMOTE DIAGNOSTICS USE CASES] Load use case vdd list attempt',
    LOAD_USE_CASE_VDD_LIST_SUCCESS = '[REMOTE DIAGNOSTICS USE CASES] Load use case vdd list success',
    LOAD_USE_CASE_VDD_LIST_FAILED = '[REMOTE DIAGNOSTICS USE CASES] Load use case vdd list failed',

    SELECT_USE_CASE_VDD_LIST = '[REMOTE DIAGNOSTICS] Select use case vdd list',

    USE_CASE_TYPE_CHANGED = '[REMOTE DIAGNOSTICS USE CASES] Use case type changed',
    USE_CASE_GROUP_CHANGED = '[REMOTE DIAGNOSTICS USE CASES] Use case group changed',
    EXTENDED_PARAMETERS_TAB_CHANGED = '[REMOTE DIAGNOSTICS USE CASES] Extended parameters tab changed',
  }

  export const loadUseCasesAttempt = createAction(
    Type.LOAD_USE_CASES_ATTEMPT,

    props<{ gatewaySerial: string }>()
  );

  export const loadUseCasesSuccess = createAction(
    Type.LOAD_USE_CASES_SUCCESS,

    props<{ useCases: UseCases }>()
  );

  export const loadUseCasesFailed = createAction(
    Type.LOAD_USE_CASES_FAILED,

    props<{ error: any }>()
  );

  export const loadUseCaseVddListAttempt = createAction(
    Type.LOAD_USE_CASE_VDD_LIST_ATTEMPT,

    props<{
      gatewaySerial: string;
      useCase: string;
    }>()
  );

  export const loadUseCaseVddListSuccess = createAction(
    Type.LOAD_USE_CASE_VDD_LIST_SUCCESS,

    props<{
      gatewaySerial: string;
      vddList: UseCaseVdd[];
    }>()
  );

  export const loadUseCaseVddListFailed = createAction(
    Type.LOAD_USE_CASE_VDD_LIST_FAILED,

    props<{ error: any }>()
  );

  export const selectUseCaseVddList = createAction(
    Type.SELECT_USE_CASE_VDD_LIST,

    props<{
      gatewaySerial: string;
      vddList?: UseCaseVdd[];
    }>()
  );

  export const useCaseTypeChanged = createAction(
    Type.USE_CASE_TYPE_CHANGED,

    props<{
      useCaseType: UseCaseTypesEnum;
      gatewaySerial: string;
    }>()
  );

  export const extendedParametersTabChanged = createAction(
    Type.EXTENDED_PARAMETERS_TAB_CHANGED,

    props<{
      tab: ExtendedParametersTabsEnum;
      gatewaySerial: string;
    }>()
  );

  export const useCaseGroupChanged = createAction(
    Type.USE_CASE_GROUP_CHANGED,

    props<{
      gatewaySerial: string;
      useCaseGroupe: string;
    }>()
  );
}
